module.exports = __webpack_public_path__ + "assets/analytics_marker-onMarket.3c2b28c9.svg";